module.exports = __webpack_public_path__ + "150d51a63df248e02a09a2885793d8b9.ttf";